import React from "react";
import {connect} from "react-redux";
import {follow, getFriends, setActivePage, unFollow} from "../../Redux/friendsReducer";
import Friends from "./Friends";
import Preloader from "../../Utilits/Preloader/Preloader";
import {setActivePageSite} from "../../Redux/authReducer";
import "./Friends.sass"
import {compose} from "redux";
import withRedirect from "../../Utilits/Redirect";




class FriendsContainer extends React.Component {

    componentDidMount() {
        this.props.getFriends(this.props.activePage, this.props.pageSize);
        this.props.setActivePageSite("FRIENDS");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.activePage !== this.props.activePage)
            this.props.getFriends(this.props.activePage, this.props.pageSize)
    }

    onSubmit = (formData) => {
        this.props.getFriends(this.props.activePage,this.props.pageSize, formData.term)
    };

    render() {
        return (
            <>
                {this.props.isPreloader ? <Preloader/> : null}
                <Friends friends={this.props.friends}
                         follow={this.props.follow}
                         unFollow={this.props.unFollow}
                         totalCount={this.props.totalCount}
                         activePage={this.props.activePage}
                         pageSize={this.props.pageSize}
                         waitingSubscripe={this.props.waitingSubscripe}
                         setActivePage={this.props.setActivePage}
                         onSubmit={this.onSubmit}
                />
            </>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        friends: state.friendsPage.friends,
        totalCount: state.usersPage.totalCount,
        activePage: state.friendsPage.activePage,
        pageSize: state.usersPage.pageSize,
        waitingSubscripe: state.usersPage.waitingSubscripe,
        isPreloader: state.friendsPage.isPreloader
    }
};


export default compose(
    connect(mapStateToProps, {getFriends, follow, unFollow, setActivePage, setActivePageSite}),
    withRedirect
)(FriendsContainer)
